import React, { Component } from 'react'
import FieldsRenderer from '@rwitl/screen-renderer/lib/FieldsRenderer'
import generateKey from '@rwitl/reformed-util/lib/generateKey'
import DropTarget from './DropTarget'
import ReactDOM from 'react-dom'

class CustomFieldsRenderer extends Component {

  constructor(props){
    super(props)
    // We use this in order to determine UI elements on hover
    this.editorKey_ = `editor-${props.blockKey}`
    this.dropTargetKey_ = generateKey()
  }

  static defaultProps = {
    // For testing
    //dragging: true,
    //onDrop: function(){},
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.blockKey != this.props.blockKey)
      throw new Error(`Changing block key would make the editor key out of sync
        this isn't handled. Write some code to handle it if you like.`
        .replace(/\s+/g, ' '))
  }


  componentDidMount = () => {
    document.body.addEventListener('mousemove', this.onMouseMove)
    document.body.addEventListener('mouseup', this.onMouseUp)
  }

  componentWillUnmount = () => {
    document.body.removeEventListener('mousemove', this.onMouseMove)
    document.body.removeEventListener('mouseup', this.onMouseUp)
  }

  onMouseMove = (e) => {
    const { dragging, renderedFields } = this.props
    if (!dragging) return

    // Don't do anything if the mouse move was outside of the container, although
    // we will remove the current drop target
    if (!this.container_) return
    var container = ReactDOM.findDOMNode(this.container_)
    if (isChildOf(e.target, container) == false)
      return this.onLastTarget(null)

    var { block, controlKey } = getBlockParent(e.target, this.editorKey_)
    if (!block){
      // This can happen if we are still inside the container but have hovered
      // over one of the block parent parents so that it won't find
      // a block but is still within the editor. Particular likely around the
      // edge, we won't remove the last target as we don't want it to flicker
      // around the edge
      return
    }
    // The block may be the drop target in which case we don't want to take
    // any action when hovering over that
    if (controlKey == this.dropTargetKey_){
      // In this case we don't want to remove the last target as it would
      // seem buggy removing the current drop target when the user is still
      // hovering over the area
      return
    }
    if (renderedFields.includes(controlKey) == false){
      throw new Error(`Unexpected 'controlKey' ${controlKey}.`)
    }
    var { top, height } = block.getBoundingClientRect()
    var midPos = (top + window.scrollY) + (height / 2)
    var deltaY = e.pageY - midPos
    this.onLastTarget(controlKey, deltaY)
  }

  onMouseUp = (e) => {
    const { onDrop, dragging, blockKey } = this.props
    if (!dragging) return

    // Don't do anything if the mouse up was outside of the container, although
    // we will remove the current drop target
    if (!this.container_) return
    var container = ReactDOM.findDOMNode(this.container_)
    if (isChildOf(e.target, container) == false){
      this.onLastTarget(null)
      return onDrop(false)
    }

    var { block, controlKey } = getBlockParent(e.target, this.editorKey_)


    // Whatever happens clear out the last target
    // This can't fire first because it will remove the drop element
    // which is needed to traverse the DOM and confirm it is a child
    // of this editor
    this.onLastTarget(null)

    if (block){

      if (controlKey === this.dropTargetKey_){
        // Successful drop

        const { renderedFields } = this.props
        var nextSibling = renderedFields[this.dropTargetIndex_]
        return onDrop(true, nextSibling, blockKey)
      }
    }
    onDrop(false)
  }

  onLastTarget = (controlKey, deltaY) => {
    const { onDropTargetChange } = this.props
    if (controlKey == null){
      this.lastTarget_ = null
      this.mouseYDelta_ = null
      this.forceUpdate()
      return
    }
    if (controlKey == this.dropTargetKey_) return
    this.lastTarget_ = controlKey
    // This prop indicates that the mouse is 1 pixel closer to
    // the top of the screen from the centre of the target element
    this.mouseYDelta_ = deltaY
    this.forceUpdate()
  }

  onStateChange = (screenState, renderedFields) => {
    const { onStateChange, blockKey, dragging } = this.props
    if (dragging){
      var { screenState, renderedFields } =
        removeDropTarget(screenState, renderedFields, blockKey)
    }
    onStateChange(screenState, renderedFields)
  }

  render = () => {

    var {
      screenState,
      renderedFields,
      componentMap,
      blockKey,
      dragging,
      ...otherProps,
    } = this.props

    if (dragging && this.lastTarget_){
      var {
        screenState,
        renderedFields,
        componentMap,
        index,
      } = addDropTarget(
        screenState,
        renderedFields,
        componentMap,
        blockKey,
        this.lastTarget_,
        this.mouseYDelta_,
        this.dropTargetKey_
      )
      this.dropTargetIndex_ = index
    }

    // If any fields are selected then make the editor readOnly
    var readOnly = renderedFields.some(key =>
      screenState[key]['selected'] || screenState[key]['checkboxSelected'])

    return <FieldsRenderer
      ref={el => this.container_ = el}
      {...otherProps}
      editorKey={this.editorKey_}
      onStateChange={this.onStateChange}
      screenState={screenState}
      renderedFields={renderedFields}
      componentMap={componentMap}
      blockKey={blockKey}
      readOnly={readOnly}
      showInlineButtons={false}
    />
  }
}

export default CustomFieldsRenderer

/**
 * Gets the parent element or itself that is the draft-js
 * block element
 * @param {Element} el
 * @param {string} editorKey
 * @returns {object} With keys 'block' and 'controlKey'
 */
export function getBlockParent(el, editorKey){

  /*data-block="true"
    data-editor="test-editor-key"
    data-offset-key="r3bmn4-0-0">*/

  if (
    el.getAttribute('data-block') == 'true' &&
    (editorKey ? el.getAttribute('data-editor') == editorKey : el.getAttribute('data-editor')) &&
    el.getAttribute('data-offset-key')
  ) {
    var controlKey = el.getAttribute('data-offset-key')
    controlKey = controlKey.slice(0, - "-0-0".length)
    return { block: el, controlKey }
  }

  if (el == document.body) return { block: null, controlKey: null }

  return getBlockParent(el.parentNode, editorKey)

}

/**
 * Adds a drop target component into the rendered fields
 * @param {object} screenState
 * @param {Array<string>} renderedFields
 * @param {object} componentMap
 * @param {string} targetCntrolKey
 * @param {number} delta If negative the drop target comes before the
 * targetControlKey and vice versa
 * @returns {object} With keys 'screenState', 'renderedFields' and
 * 'componentMap'
 */
function addDropTarget(
  screenState,
  renderedFields,
  componentMap,
  parentKey,
  targetControlKey,
  delta,
  dropTargetKey
){

  componentMap = Object.assign({}, componentMap, {
    dropTarget: DropTarget,
  })

  var dropField = {
    type: 'dropTarget',
    key: dropTargetKey,
  }
  screenState = Object.assign({}, screenState)
  screenState[dropField.key] = dropField

  var layout = screenState[parentKey]['layout'].slice(0)
  var index = layout.indexOf(targetControlKey)
  if (index == -1)
    throw new Error(`Did not find expected targetControlKey`)
  index = delta <= 0 ? index : (index + 1)
  layout.splice(
    index,
    0,
    dropField.key
  )
  screenState[parentKey] = Object.assign({}, screenState[parentKey])
  screenState[parentKey].layout = layout

  return {
    screenState,
    renderedFields: layout,
    componentMap,
    index,
  }
}

/**
 * Removes the drop target from the screenState and renderedFields
 * @param {object} screenState
 * @param {Array<string>} renderedFields
 * @returns {object} With keys 'screenState' and 'renderedFields'
 */
function removeDropTarget(screenState, renderedFields, parentKey){

  var dropTargetIndex = renderedFields.findIndex(key => {
    return screenState[key].type == 'dropTarget'
  })
  // Did not find drop target
  if (dropTargetIndex == -1)
    return {
      screenState,
      renderedFields,
    }

  var dropTargetKey = renderedFields[dropTargetIndex]
  renderedFields = renderedFields.slice(0)
  renderedFields.splice(dropTargetIndex, 1)
  screenState[parentKey]['layout'] = renderedFields
  delete screenState[dropTargetKey]

  return {
    screenState,
    renderedFields,
  }
}

/**
 * Checks if an element is a child of another element also returns
 * true if the child is the parent
 * @param {Element} child
 * @param {Element} parent
 * @returns {boolean}
 */
function isChildOf(child, parent){
  do {
    if (child == parent) return true
    child = child.parentNode
  } while (child != document.body && child != null)
  return false
}


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/FieldsRenderer/FieldsRenderer.js